import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

import { BlockValueStringSchema } from './blockValueStringSchema.js';
interface BlockValueUsPhoneNumberSchemaArgs {
  isRequired?: boolean;
}

/**
 * @arg isRequired - if isRequired is false, the empty string is allowed. Chain the schema with .optional() if
 * the entire config property is optional.
 * @returns A Zod schema for validating values that are either block value templates or US Phone Number string.
 */
export function BlockValueUsPhoneNumberSchema(args: BlockValueUsPhoneNumberSchemaArgs) {
  const { isRequired = false } = args;
  const blockValueOrUsPhoneNumberSchema = BlockValueStringSchema({
    stringValidationSchema: z.string().superRefine((value, context) => {
      if (!isValidPhoneNumber(value, 'US')) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid US phone number.',
        });
      }
    }),
  });
  if (isRequired) {
    return blockValueOrUsPhoneNumberSchema;
  }
  return z.union([z.literal(''), blockValueOrUsPhoneNumberSchema]);
}
